import React, { ComponentProps, ReactNode } from 'react'

import styled from '@emotion/styled'

import { FlexBox } from '..'

import { Box } from './Box'
import { Text } from './Text'

const DividerFull = styled(Box)`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.ui.colors['navy.25']};
`

interface Props extends ComponentProps<typeof Box> {
  children?: ReactNode | string
  centered?: boolean
  textProps?: ComponentProps<typeof Text>
}

export const Divider = ({
  children,
  centered = true,
  textProps = {
    ws: 'nowrap',
    size: 'xxs',
    variant: 'navy.25',
  },
  ...rest
}: Props) => {
  if (!children) {
    return <DividerFull {...rest} />
  }

  return (
    <FlexBox
      {...{ w: '100%', ai: 'center', jc: 'center', tw: 'nowrap', ...rest }}>
      {centered ? <DividerFull /> : null}
      <Box {...(centered ? { mx: 'md' } : { mr: 'md' })}>
        {typeof children === 'string' ? (
          <Text {...textProps}>{children}</Text>
        ) : (
          children
        )}
      </Box>
      <DividerFull />
    </FlexBox>
  )
}
